import {BrowserRouter, Route, Routes} from 'react-router-dom'
import './App.css';
import NavBar from './components/NavBar/NavBar';
import About from './components/About/About';

import Footer from './components/Footer/Footer';
import Btnwp from './components/Wp/Btnwp';
import Servicios from './components/About/Servicios';
import Proyectosr from './components/About/Proyectosr';
import Contactop from './components/About/Contactop';
import Principal from './components/About/Principal';
import Serviciosprincipal from './components/Servicios/Serviciosprincipal';
import Desarrolloweb from './components/Servicios/Desarrolloweb';
import Portfoliosweb from './components/Servicios/Portfoliosweb';
import Alojamientoweb from './components/Servicios/Alojamientoweb';
import Acercas from './components/Acerca/Acercas';
import Proyectos from './components/Proyectos/Proyectos';
import Contacto from './components/Contacto/Contacto';
function App() {
  return (
    <BrowserRouter>
    
      <NavBar />
     <Routes>
     <Route path="/" element={<About/>} /> 
      <Route path="/home" element={<About/>} />
      <Route path="/PortfolioWeb" element={<About/>} />
      <Route path="/About" element={<Acercas/>}  />
      <Route path="/Servicios" element={<Serviciosprincipal/>} />
      <Route path="/Servicios/desarrollo-web" element={<Desarrolloweb/>} />
      <Route path="/Servicios/portfolio-web" element={<Portfoliosweb/>} />
      <Route path="/Servicios/alojamiento-web" element={<Alojamientoweb/>} />
      <Route path="/proyectos" element={<Proyectos/>} />
      <Route path="/contacto" element={<Contacto/>}  />

      </Routes>
      {/* <Footer/> */}
      <Btnwp/>
    </BrowserRouter>

  );
}

export default App;
